import React from 'react';
import PropTypes from 'prop-types';

import pluginTypes from 'constants/pluginTypes';
import enhanceWithServices from 'hocs/enhanceWithServices';
import templateServiceShape from 'services/types/templateService';

import TemplateTile from './components/TemplateTile';
import { TemplatesListContainer } from './styles';

class TemplateSelectionView extends React.Component {
  handleTemplateSelection = (templateId) => () => {
    const { onTemplateSelect } = this.props;
    if (onTemplateSelect && templateId) {
      onTemplateSelect(templateId);
    }
  };

  render() {
    const { templateService, selectedCategory, pluginType } = this.props;
    const templates = templateService.getTemplates(pluginType, selectedCategory);
    return (
      <TemplatesListContainer>
        { templates && templates.map((template, index) => (
          <TemplateTile
            key={`template-tile-${template.templateId || index}`}
            title={template.title}
            templateId={template.templateId}
            templateType={template.templateType}
            description={template.description}
            thumbnailUrl={template.thumbnail}
            onSelect={this.handleTemplateSelection(template.templateId)}
            disablePreview={pluginType === pluginTypes.SCREEN}
          />
        ))}
      </TemplatesListContainer>
    );
  }
}

TemplateSelectionView.propTypes = {
  onTemplateSelect: PropTypes.func,
  templateService: templateServiceShape,
  selectedCategory: PropTypes.string,
  pluginType: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

export default enhanceWithServices(TemplateSelectionView);
